import { render } from "./Overlays.vue?vue&type=template&id=5bb66a6a"
import script from "./Overlays.vue?vue&type=script&lang=js"
export * from "./Overlays.vue?vue&type=script&lang=js"

import "./Overlays.vue?vue&type=style&index=0&id=5bb66a6a&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__